import { shareCertificate} from '@/api/certificate'
export const shareMixin = {

  data () {
    return {
      selected_share_id:[],
      share_id:[]
    }
  },
  methods:{
    async share (id,  type) {
      if (type === 'single') {
        this.selected_share_id[0] = id
      }
      this.share_id.length = 0
      this.share_id[0] = id
      this.share_certificate('single')
     
      
    },

    async share_certificate (type) {
      const customer_id = this.$store.getters.customerId
      let payload = []
      let share= false
      try {
        if (type === 'bulk') {
          console.log(this.selectedGenCertificate)
          const ids = this.selectedGenCertificate.map(ele => {
            if(ele.is_shared==false){
              return ele.certificate_id
            } else {
              share=true;
            }
           
          })
          
         
          payload = {
            certificate_ids:ids
          }

        } else {
          payload = {
            certificate_ids:this.share_id
          }
        }
        if(!share){
          await shareCertificate(payload, customer_id)
          this.fetchgeneratedCertificate()
          this.$vs.notify({
            title: 'Success',
            text: 'Shared Certificate Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 3000
          })
          this.selected.length = 0 
        } else {
          this.$vs.notify({
            title: 'Warning',
            text: 'Shared certificate cannot be shared"',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
          this.selected.length = 0
        }
       

      } catch (error) {}
    },

    bulkShare () {
      this.share_certificate('bulk')
    }
  }
}